import axios from 'axios'
import { DocumentCommentThread, DocumentChangeSet, DocumentComment } from '../types'

// Configure base URL if needed, or rely on proxy/relative paths
const API_URL = '/api'

export const reviewAPI = {
    // Comments
    getComments: async (documentId: string, includeResolved: boolean = false): Promise<DocumentCommentThread[]> => {
        const response = await axios.get(`${API_URL}/documents/${documentId}/comments`, {
            params: { include_resolved: includeResolved }
        })
        return response.data
    },

    createThread: async (documentId: string, anchor: any, body: string): Promise<DocumentCommentThread> => {
        const response = await axios.post(`${API_URL}/documents/${documentId}/comments/threads`, {
            anchor,
            body
        })
        return response.data
    },

    replyToThread: async (documentId: string, threadId: string, body: string): Promise<DocumentComment> => {
        const response = await axios.post(`${API_URL}/documents/${documentId}/comments/threads/${threadId}/reply`, {
            body
        })
        return response.data
    },

    resolveThread: async (documentId: string, threadId: string): Promise<void> => {
        await axios.post(`${API_URL}/documents/${documentId}/comments/threads/${threadId}/resolve`)
    },

    deleteComment: async (documentId: string, commentId: string): Promise<void> => {
        await axios.delete(`${API_URL}/documents/${documentId}/comments/${commentId}`)
    },

    // History & Track Changes
    getHistory: async (documentId: string, limit: number = 50, offset: number = 0): Promise<DocumentChangeSet[]> => {
        const response = await axios.get(`${API_URL}/documents/${documentId}/history`, {
            params: { limit, offset }
        })
        return response.data
    },

    getTrackChanges: async (documentId: string): Promise<DocumentChangeSet[]> => {
        const response = await axios.get(`${API_URL}/documents/${documentId}/track-changes`)
        return response.data
    },

    revertChangeSet: async (documentId: string, changeSetId: string): Promise<void> => {
        await axios.post(`${API_URL}/documents/${documentId}/history/track-changes/${changeSetId}/revert`)
    }
}
